/* This is the EMIS Teaching and non teaching staff for primary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយ
            </td>
            <td class="row-header" colspan="2">បានបណ្ដុះបណ្ដាល</td>
            <td class="row-header" colspan="2">មិនបានបណ្ដុះបណ្ដាល</td>
            <td class="row-header" colspan="2">
              បានបណ្ដុះបណ្ដាលប៉ុន្ដែមិនបង្រៀន
            </td>
          </tr>
          <tr>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in d4.length - lastRow" :key="row">
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ d4[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].dt[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { d4 } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "cur_cod", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d4: d4,
    };
  },
  computed: {
    //variable control the last added row of 20-21
    lastRow: function () {
      if (this.cur_cod > 12) return 0;
      else return 2;
    },
  },
};
</script>

<style scoped>
.number {
  width: 100px;
  text-align: center;
}
.row-data {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header {
  width: 200px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>